export enum MapWidgetPosition {
    RIGHT = "R",
    LEFT = "L",
    TOP = "T",
    TOP_HEADER = "TH",
    BOTTOM = "B",
    BOTTOM_RIGHT = "BR",
    BOTTOM_FOOTER = "BF",
    HIDDEN = "H",
}
